import React from 'react'

interface Props {
  id: string
  dx: number
  dy: number
  stdDeviation: number
  floodColor: string
}

export const ShadowFilter: React.FC<Props> = ({ id, dx, dy, floodColor, stdDeviation }) => {
  return (
    <defs>
      <filter id={id} filterUnits="userSpaceOnUse" x="-50%" y="-50%" width="150%" height="150%">
        <feDropShadow dx={dx} dy={dy} stdDeviation={stdDeviation} floodColor={floodColor} />
      </filter>
    </defs>
  )
}
